module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-arrow.dd7fa117.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-arrow.png
// module id = 3174
// module chunks = 11